import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../../../../axiosClient";

const BACKEND_URL = process.env.REACT_APP_LARAVEL_API;

export const addShiftJob = createAsyncThunk(
    "shiftJob/addShiftJob",
    async ({ token, payload }, thunkAPI) => {
        console.log("token", token);
        console.log("payload", payload);

        try {
            const res = await axios.post(
                `${BACKEND_URL}/create-shift-request`,
                payload,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                }
            );
            return res.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(
                error.response?.data || "API call failed"
            );
        }
    }
);

export const getShiftJobs = createAsyncThunk(
    "shiftJob/getShiftJobs",
    async ({ token, page = 1 }, thunkAPI) => {
        try {
            const res = await axios.get(
                `${BACKEND_URL}/list-shift-request?page=${page}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
            );
            return res.data.data.shift_request;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response?.data || "Fetch failed");
        }
    }
);

export const getShiftJobDetails = createAsyncThunk(
    "shiftJob/getShiftJobDetails",
    async ({ id, token }, thunkAPI) => {
        try {
            const res = await axios.get(
                `${BACKEND_URL}/shift-request/${id}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            // ✅ return everything
            return res.data.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(
                error.response?.data || "Fetch failed"
            );
        }
    }
);


export const editShiftJob = createAsyncThunk(
    "shiftJob/editShiftJob",
    async ({ id, token, payload }, thunkAPI) => {
        try {
            const res = await axios.post(
                `${BACKEND_URL}/update-shift-request/${id}`,
                payload,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                }
            );
            return res.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(
                error.response?.data || "API call failed"
            );
        }
    }
);

export const deleteShiftJob = createAsyncThunk(
    "shiftJob/deleteShiftJob",
    async ({ token, id }, thunkAPI) => {
        try {
            const res = await axios.post(
                `${BACKEND_URL}/delete-shift-request/${id}`,
                {},
                {
                    headers: { Authorization: `Bearer ${token}` },
                }
            );
            return { id, message: res.data.message || "Shift Job deleted successfully" };
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response?.data || "Delete failed");
        }
    }
);

export const getShiftAssigendJobs = createAsyncThunk(
    "shiftJob/shiftAssigendJobs",
    async (token, thunkAPI) => {
        try {
            const res = await axios.get(
                `${BACKEND_URL}/shiftRequestEmpjoblist`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
            );
            return res.data.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response?.data || "Fetch failed");
        }
    }
);

export const getShiftAssigendJobDetails = createAsyncThunk(
    "shiftJob/shiftAssigendJobDetails",
    async ({ id, token }, thunkAPI) => {
        try {
            const res = await axios.get(
                `${BACKEND_URL}/shiftRequestEmploglist/${id}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
            );
            return res.data.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response?.data || "Fetch failed");
        }
    }
);

export const updateEmployerApproval = createAsyncThunk(
    "shiftJob/updateEmployerApproval",
    async ({ payload, token }, thunkAPI) => {

        try {
            const res = await axios.post(
                `${BACKEND_URL}/updatehoursStatusbyemp`,
                payload,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                }
            );
            return res.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(
                error.response?.data || "API call failed"
            );
        }
    }
);

const workerShiftJobSlice = createSlice({
    name: "workerShiftJob",
    initialState: {
        shiftJobData: [],
        pagination: {},
        shiftJobDetails: {
            shift_request: null,
            shift_request_assigns: [],
            shift_request_approve: [],
        },
        shiftAssignedJobs: [],
        shiftAssigendJobDetails: {
            shift_request_emp: null,
            shift_request_logs: [],
            approval_total_hours: null,
            total_hours: null,
        },
        loading: false,
        error: null,
    },
    extraReducers: (builder) => {
        builder
            .addCase(addShiftJob.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(addShiftJob.fulfilled, (state, action) => {
                state.loading = false;
                state.message = action.payload?.message || "Shift Job created successfully";
            })
            .addCase(addShiftJob.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || "Something went wrong";
            })
            .addCase(getShiftJobs.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getShiftJobs.fulfilled, (state, action) => {
                state.loading = false;

                state.shiftJobData = action.payload.data;

                state.pagination = {
                    current_page: action.payload.current_page,
                    last_page: action.payload.last_page,
                    total: action.payload.total,
                    per_page: action.payload.per_page,
                };
            })

            .addCase(getShiftJobs.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(getShiftJobDetails.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getShiftJobDetails.fulfilled, (state, action) => {
                state.loading = false;

                state.shiftJobDetails = {
                    shift_request: action.payload.shift_request,
                    shift_request_assigns: action.payload.shift_request_assigns || [],
                    shift_request_approve: action.payload.shift_request_approve || [],
                };
            })
            .addCase(getShiftJobDetails.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(editShiftJob.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(editShiftJob.fulfilled, (state, action) => {
                state.loading = false;
                state.message = action.payload?.message || "Shift Job updated successfully";
            })
            .addCase(editShiftJob.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || "Something went wrong";
            })
            .addCase(deleteShiftJob.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(deleteShiftJob.fulfilled, (state, action) => {
                state.loading = false;
                state.shiftJobData = state.shiftJobData.filter(job => job.id !== action.payload.id);
                state.message = action.payload.message;
            })
            .addCase(deleteShiftJob.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(getShiftAssigendJobs.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getShiftAssigendJobs.fulfilled, (state, action) => {
                state.loading = false;
                state.shiftAssignedJobs = action.payload.shift_request_emp;
            })
            .addCase(getShiftAssigendJobs.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(getShiftAssigendJobDetails.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getShiftAssigendJobDetails.fulfilled, (state, action) => {
                state.loading = false;
                state.shiftAssigendJobDetails = {
                    shift_request_emp: action.payload.shift_request_emp || null,
                    shift_request_logs: action.payload.shift_request_logs || [],
                    approval_total_hours: action.payload.approval_total_hours || null,
                    total_hours: action.payload.total_hours || null,
                };
            })
            .addCase(getShiftAssigendJobDetails.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(updateEmployerApproval.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(updateEmployerApproval.fulfilled, (state, action) => {
                state.loading = false;
                state.message = action.payload?.message || "Shift Job created successfully";
            })
            .addCase(updateEmployerApproval.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || "Something went wrong";
            })
    },
});

export default workerShiftJobSlice.reducer;
